module.exports = __webpack_public_path__ + "img/theme10.604fdc10.png";